// src/MainRouter.js

import { BrowserRouter, Route, Routes } from "react-router-dom";

import About from "./pages/about";
import Blog from "./pages/blog";
import BlogSingle from "./pages/blog-single";
import Contact from "./pages/contact";
import Event from "./pages/event";
import EventDetails from "./pages/event-details";
import Home from "./pages/index";
import Homev2 from "./pages/homev2";
import Homev3 from "./pages/homev3";
import Layout from "./components/layout/Layout";
import React from "react";
import TFDAccelerate from "./pages/tfdAccelerate/TFDAccelerate";
import TFDAccelerateAcademy from "./pages/tfdAccelerate/TFDAccelerateAcademy";
import TFDAccelerateCamps from "./pages/tfdAccelerate/TFDAccelerateCamps";
import TFDAccelerateEuropaLeague from "./pages/tfdAccelerate/TFDAccelerateEuropaLeague";
import TFDAccelerateInternationalExperience from "./pages/tfdAccelerate/TFDAccelerateInternationalExperience";
import TFDAccelerateLittleSuperstars from "./pages/tfdAccelerate/TFDAccelerateLittleSuperstars";
import TFDAccelerateNationalTours from "./pages/tfdAccelerate/TFDAccelerateNationalTours";
import TFDAcceleratePrivate from "./pages/tfdAccelerate/TFDAcceleratePrivate";
import TFDAccelerateSchools from "./pages/tfdAccelerate/TFDAccelerateSchools";
import TFDSelect from "./pages/tfdSelect/TFDSelect";
import TFDSelectAcademy from "./pages/tfdSelect/TFDSelectAcademy";
import TFDSelectCamps from "./pages/tfdSelect/TFDSelectCamps";
import TFDSelectChampionsLeague from "./pages/tfdSelect/TFDSelectChampionsLeague";
import TFDSelectInternationalTours from "./pages/tfdSelect/TFDSelectInternationalTours";
import TFDSelectMeetTheTeam from "./pages/tfdSelect/TFDSelectMeetTheTeam";
import TFDSelectNationalTours from "./pages/tfdSelect/TFDSelectNationalTours";
import TFDSelectPlayerHistory from "./pages/tfdSelect/TFDSelectPlayerHistory";
import TFDSelectPrivate from "./pages/tfdSelect/TFDSelectPrivate.js";

// ===== Old Existing Pages =====

// ===== Footer (from new router) =====

// ===== TFD SELECT Pages =====

// import TFDSelectPrivate from "./pages/tfdSelect/TFDSelectPrivate"; // Uncomment if/when you have it

// ===== TFD ACCELERATE Pages =====







export default function MainRouter() {
	return (
		<BrowserRouter>
			<Layout>
				<Routes>
					{/* ====== Old Existing Routes ====== */}
					<Route path="/" element={<Home />} />
					{/* <Route path="/about" element={<About />} />
					<Route path="/blog" element={<Blog />} />
					<Route path="/blog-single" element={<BlogSingle />} />
					<Route path="/event" element={<Event />} />
					<Route path="/event-details" element={<EventDetails />} />
					<Route path="/homeV2" element={<Homev2 />} />
					<Route path="/homeV3" element={<Homev3 />} /> */}
					<Route path="/contact" element={<Contact />} />
					{/* ====== TFD SELECT ====== */}
					<Route path="/tfd-select" element={<TFDSelect />} />
					<Route path="/tfd-select/academy" element={<TFDSelectAcademy />} />
					{/* <Route path="/tfd-select/private-sessions" element={<TFDSelectPrivate />} /> */}
					<Route
						path="/tfd-select/perth-champions-league"
						element={<TFDSelectChampionsLeague />}
					/>
					<Route path="/tfd-select/camps" element={<TFDSelectCamps />} />
					<Route
						path="/tfd-select/national-tours"
						element={<TFDSelectNationalTours />}
					/>
					<Route
						path="/tfd-select/international-tours"
						element={<TFDSelectInternationalTours />}
					/>
					<Route
						path="/tfd-select/player-history"
						element={<TFDSelectPlayerHistory />}
					/>
					<Route
						path="/tfd-select/meet-the-team"
						element={<TFDSelectMeetTheTeam />}
					/>{" "}
					<Route
						path="/tfd-select/private-sessions"
						element={<TFDSelectPrivate />}
					/>
					{/* ====== TFD ACCELERATE ====== */}
					<Route path="/tfd-accelerate" element={<TFDAccelerate />} />
					<Route
						path="/tfd-accelerate/academy"
						element={<TFDAccelerateAcademy />}
					/>
					<Route
						path="/tfd-accelerate/private-sessions"
						element={<TFDAcceleratePrivate />}
					/>
					<Route
						path="/tfd-accelerate/perth-europa-league"
						element={<TFDAccelerateEuropaLeague />}
					/>
					<Route path="/tfd-accelerate/camps" element={<TFDAccelerateCamps />} />
					<Route path="/tfd-accelerate/schools" element={<TFDAccelerateSchools />} />
					<Route path="/tfd-accelerate/little-superstars" element={<TFDAccelerateLittleSuperstars />} />
					<Route path="/tfd-accelerate/national-tours" element={<TFDAccelerateNationalTours />} />
					<Route
          path="/tfd-accelerate/international-experience"
          element={<TFDAccelerateInternationalExperience />}
        />
				</Routes>

				{/* FOOTER from the new setup */}
			</Layout>
		</BrowserRouter>
	);
}
